import React from 'react';
import { Container, Media } from '../../components';
import { CoreValuesMobile } from './mobile';
import { CoreValuesTablet } from './tablet';
import { CoreValuesDesktop } from './desktop';
import styled from 'styled-components';

const DesktopWrapper = styled.div`
  background-color: #faf2f4;
`;

export const CoreValues = React.forwardRef<any>((props, ref) => {
  return (
    <section ref={ref}>
      <Container>
        <Media at="sm">
          <CoreValuesMobile />
        </Media>
      </Container>
      <Container>
        <Media at="md">
          <CoreValuesTablet />
        </Media>
      </Container>
      <DesktopWrapper>
        <Container>
          <Media greaterThanOrEqual="xmd">
            <CoreValuesDesktop />
          </Media>
        </Container>
      </DesktopWrapper>
    </section>
  );
});
